module.exports = __webpack_public_path__ + "static/media/gcdef_10055.c5aa9ced.ico";